/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsbyCategoryListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: ProductsbyCategoryService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { ProductsbyCategoryData, ProductsbyCategoryService } from './ProductsbyCategory.service';
import { ProductsbyCategorySearchComponent }  from './ProductsbyCategorySearch.component';

@Component({
	selector: 'my-ProductsbyCategory',
	template: require('./ProductsbyCategoryList.component.html'),
	providers: [ProductsbyCategoryService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class ProductsbyCategoryListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	ProductsbyCategoryList: ProductsbyCategoryData[];
	newProductsbyCategory: ProductsbyCategoryData;
	selectedProductsbyCategory: ProductsbyCategoryData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(ProductsbyCategorySearchComponent) filterComponent: ProductsbyCategorySearchComponent;

	sortExpression: string = "CategoryName";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private ProductsbyCategoryService: ProductsbyCategoryService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newProductsbyCategory = new ProductsbyCategoryData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.ProductsbyCategoryService.getAll().subscribe(record => this.ProductsbyCategoryList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getProductsbyCategoryByPaging();

		/*
		this.ProductsbyCategoryList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getProductsbyCategory() {
		this.ProductsbyCategoryService.getAll()
			.subscribe(data => this.ProductsbyCategoryList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on ProductsbyCategorySearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getProductsbyCategoryByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getProductsbyCategoryByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getProductsbyCategoryByPaging();
	}
	
	// Get records by paging
	getProductsbyCategoryByPaging() {
		this.ProductsbyCategoryService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.ProductsbyCategoryList=data.ProductsbyCategoryList;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addProductsbyCategory() {
		this.ProductsbyCategoryService.addProductsbyCategoryData(this.newProductsbyCategory).subscribe(record => console.log(record));
		this.getProductsbyCategory();
	}
  
	// Updates existing record
	updateProductsbyCategory() {
		this.ProductsbyCategoryService.updateProductsbyCategoryData(this.selectedProductsbyCategory).subscribe(record => console.log(record));
		this.getProductsbyCategory();
	}

	// Deletes record with specified id
	deleteProductsbyCategory(id: string) {
		if (window.confirm('Are you sure you want to delete this ProductsbyCategory?') == true)
		{
			this.ProductsbyCategoryService.deleteProductsbyCategory(id)
			.subscribe(data => this.getProductsbyCategory(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getProductsbyCategoryByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getProductsbyCategoryByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getProductsbyCategoryByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getProductsbyCategoryByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: ProductsbyCategoryData) {
		this.router.navigate(['/ProductsbyCategory', item.CategoryName]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: ProductsbyCategoryData) {
		this.router.navigate(['/ProductsbyCategory/Details', item.CategoryName]);
	}

	// Set record as selected
	SelectProductsbyCategory(item: ProductsbyCategoryData) {
		this.selectedProductsbyCategory = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: ProductsbyCategoryData) {
		return item.CategoryName === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/ProductsbyCategory/ProductsbyCategoryList.component.ts